<template>
	<v-navigation-drawer
		id="app-drawer"
		v-model="getDrawer"
		app
		:mini-variant.sync="getDrawer"
		permanent
	>
		<!--div class="cover"></div-->
		<v-list class="pa-1">
			<v-list-item class="pointer" @click="pushRoute('dashboard')">
				<v-list-item-avatar>
					<v-img src="/images/reverencehotels.png" height="50" contain></v-img>
				</v-list-item-avatar>
				<v-list-item-content>
					<v-list-item-title class="body primary--text"
						>REVERENCE HOTELS
					</v-list-item-title>
				</v-list-item-content>
			</v-list-item>
		</v-list>
		<v-divider></v-divider>

		<template v-if="getExpanseMenu.length > 0">
			<v-list nav dense class="pb-0" v-if="!getDrawer">
				<v-list-group
					v-for="(expanse, i) in getExpanseMenu"
					:key="i * 0.000015"
					no-action
				>
					<template v-slot:activator>
						<v-list-item-icon class="mr-0">
							<v-icon>{{ expanse.icon }}</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title>{{ expanse.title }}</v-list-item-title>
						</v-list-item-content>
					</template>

					<v-list-item
						v-for="subItem in expanse.items"
						:key="subItem.title"
						link
						@click="pushRoute(subItem.link)"
						class="pl-10"
					>
						<v-list-item-icon class="mr-0">
							<v-icon>{{ subItem.icon }}</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title>{{ subItem.title }}</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list-group>
			</v-list>
			<v-list nav dense class="pb-0" v-else>
				<v-list-item-group color="primary">
					<v-list-item
						v-for="(item, i) in getDrawerExpanseMenus"
						:key="i"
						link
						@click="pushRoute(item.link)"
					>
						<v-tooltip right v-if="getDrawer">
							<template v-slot:activator="{ on }">
								<v-list-item-icon v-on="on">
									<v-icon>{{ item.icon }}</v-icon>
								</v-list-item-icon>
							</template>
							<span>{{ item.title }}</span>
						</v-tooltip>
						<v-list-item-content></v-list-item-content>
					</v-list-item>
				</v-list-item-group>
			</v-list>
		</template>

		<v-list nav dense class="pb-0">
			<v-list-item-group v-model="getMenuModel" color="primary">
				<v-list-item
					v-for="(item, i) in getMenu"
					:key="i"
					link
					@click="pushRoute(item.link)"
				>
					<v-tooltip right v-if="getDrawer">
						<template v-slot:activator="{ on }">
							<v-list-item-icon v-on="on">
								<v-icon>{{ item.icon }}</v-icon>
							</v-list-item-icon>
						</template>
						<span>{{ item.title }}</span>
					</v-tooltip>
					<v-list-item-icon v-else class="mr-0">
						<v-icon>{{ item.icon }}</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>{{ item.title }}</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-list-item-group>

			<template v-if="getAdmin.length > 0">
				<v-divider></v-divider>
				<v-list nav dense class="pb-0" v-if="!getDrawer">
					<v-list-group v-model="adminActive" no-action>
						<template v-slot:activator>
							<v-list-item-icon class="mr-0">
								<v-icon>mdi-cog-outline</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title>Ajustes</v-list-item-title>
							</v-list-item-content>
						</template>

						<v-list-item
							v-for="subItem in getAdmin"
							:key="subItem.title"
							link
							@click="pushRoute(subItem.link)"
							class="pl-10"
						>
							<v-list-item-icon class="mr-0">
								<v-icon>{{ subItem.icon }}</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title>{{ subItem.title }}</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list-group>
				</v-list>
				<v-list nav dense class="pb-0" v-else>
					<v-list-item-group v-model="getSettingsMenuModel" color="primary">
						<v-list-item
							v-for="(item, i) in getAdmin"
							:key="i"
							link
							@click="pushRoute(item.link)"
						>
							<v-tooltip right v-if="getDrawer">
								<template v-slot:activator="{ on }">
									<v-list-item-icon v-on="on">
										<v-icon>{{ item.icon }}</v-icon>
									</v-list-item-icon>
								</template>
								<span>{{ item.title }}</span>
							</v-tooltip>
							<v-list-item-content></v-list-item-content>
						</v-list-item>
					</v-list-item-group>
				</v-list>
			</template>
		</v-list>

		<template v-slot:append>
			<div class="px-4 py-2">
				<v-btn block color="primary" @click="$auth.logout()">
					<template v-if="!getDrawer">logout</template>
					<v-icon class="px-0" v-else>mdi-logout</v-icon>
				</v-btn>
			</div>
		</template>
	</v-navigation-drawer>
</template>

<script>
import { base } from "~/mixins/base.js";

export default {
	mixins: [base],
	created() {
		// Paso 1: Filtrar elementos con setting a true y asignarlos a this.admin
		this.admin = this.items.filter((item) => item.setting);

		// Paso 2: Preparar estructura para menús expansibles con sus elementos
		const menuTreeIDs = [
			...new Set(
				this.items
					.filter((item) => item.MenuTreeID > 0)
					.map((item) => item.MenuTreeID),
			),
		];

		this.expanseMenus = menuTreeIDs
			.map((id) => ({
				...this.items.find((item) => item.MenuTree && item.MenuTree.ID === id)
					.MenuTree,
				items: [],
			}))
			.sort((a, b) => a.order - b.order);

		// Agregar ítems a sus respectivos menús expansibles
		this.items.forEach((item) => {
			if (item.MenuTreeID > 0) {
				const parentMenu = this.expanseMenus.find(
					(menu) => menu.ID === item.MenuTreeID,
				);
				if (parentMenu) {
					parentMenu.items.push(item);
				}
			}
		});

		this.items
			.filter((e) => {
				if (!e.setting && e.MenuTreeID > 0) {
					this.drawerExpanseMenus.push(e);
				}
			})
			.sort((a, b) => {
				return a.order - b.order;
			});

		this.drawerExpanseMenus = this.drawerExpanseMenus.sort(
			(a, b) => a.order - b.order,
		);

		// Ordenar los elementos dentro de cada menú expansible
		this.expanseMenus.forEach((menu) =>
			menu?.items.sort((a, b) => a.order - b.order),
		);
	},
	searchItemIntoArray(items, key, search) {
		return items.find(function (item) {
			return item["key"] === search;
		});
	},
};
</script>

<style lang="scss">
#app-drawer {
	//background-image: url("https://picsum.photos/id/251/300/1200");
	background-color: #f5f5f5;

	.v-list-item__title {
		text-overflow: inherit !important;
		white-space: pre-wrap !important;
	}

	.cover {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		background: #000;
		opacity: 0.25;
	}

	.v-list__tile {
		border-radius: 4px;

		&--buy {
			margin-top: auto;
			margin-bottom: 17px;
		}
	}

	.v-image__image--contain {
		top: 9px;
		height: 60%;
	}

	.search-input {
		margin-bottom: 30px !important;
		padding-left: 15px;
		padding-right: 15px;
	}

	div.v-responsive.v-image > div.v-responsive__content {
		overflow-y: auto;
	}

	.v-list-item__icon,
	.v-list-item__title {
		font-weight: 900;
	}
}
</style>
